import BaseModelAPI from '../BaseModelAPI';

export default class SuratJalanDeliverySubconList extends BaseModelAPI {

	static entity = 'suratjalandeliverysubconlist'
	static entityName = 'suratjalandeliverysubcon';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
